export function abcdefgh() {
	console.log(1);
}

export function demo() {}

export function xyz() {}
